export const COMPANY = "company";
export const DO_NOT_SHIP = "do_not_ship";
export const DROPSHIP = "dropship";
export const USA = "USA";
export const IRE = "IRE";
export const SGP = "SGP";
export const APPROVED = "approved";
export const AS_REMOVED = "as_removed";

export const ALTERNATE_ID = "alternate_id";
export const ALLOCATE_TO_SO = "allocate_to_so";
export const ALLOW_SENDING = "allow_sending";
export const AMOUNT_PAID = "amount_paid";
export const AMOUNT_INSURED = "amount_insured";
export const ASSIGNED_CORE_RETURN_ID = "assigned_core_return_id";
export const ASSIGNED_CORE_RETURN = "assigned_core_return";
export const BUYING_STORE_ID = "buying_store_id";
export const CANCELLATION_REASON = "cancellation_reason";
export const CAP_AMOUNT = "cap_amount";
export const CAP_TYPE = "cap_type";
export const CONTAINER_FEE = "container_fee";
export const CORE_DUE_DATE = "core_due_date";
export const CORE_REPAIR_FEE_NOT_TO_EXCEED = "core_repair_fee_not_to_exceed";
export const DIM_WEIGHT = "dim_weight";
export const EVALUATION_PERIOD = "evaluation_period";
export const EXPECTED_SERIAL_NUMBER = "expected_serial_number";
export const EXTERNAL_NOTE = "external_note";
export const HAZMAT_FEE = "hazmat_fee";
export const INCIDENT = "incident";
export const INTERNAL_NOTE = "internal_note";
export const INSURANCE_TYPE = "insurance_type";
export const INVOICE_NUMBER = "invoice_number";
export const PERCENT_INSURED = "percent_insured";
export const PORTAL_PURCHASE = "portal_purchase";
export const PURCHASE_FOR_STOCK = "purchase_for_stock";
export const PURCHASE_FOR_REPAIR = "purchase_for_repair";
export const PURCHASE_FOR_SALE = "purchase_for_sale";
export const PURCHASE_FOR_REPAIR_ASSIST = "purchase_for_repair_assist";
export const PAYMENT_TERMS = "payment_terms";
export const PREFERRED_REPAIR_STATION_ID = "preferred_repair_station_id";
export const PREFERRED_REPAIR_STATION_HOLD = "preferred_repair_station_hold";
export const PURCHASED_FOR_SOLI_ID = "purchased_for_soli_id";
export const QC_HOLD = "qc_hold";
export const REJECTED = "rejected";
export const RESERVE_FOR_SALE_QUANTITY = "reserve_for_sale_quantity";
export const REQUIRES_APPROVAL = "requires_approval";
export const REQUIRES_APPROVAL_EXCEPT_TRACE_HOLD =
  "requires_approval_except_trace_hold";
export const TOOL_USED = "tool_used";
export const TRACE_HOLD = "trace_hold";
export const TRACE_HOLD_APPROVED = "trace_hold_approved";
export const VENDOR_CORE_REPAIR_INVOICE_AMOUNT_PAID =
  "vendor_core_repair_invoice_amount_paid";
export const VENDOR_CORE_REPAIR_INVOICE_DUE_DATE =
  "vendor_core_repair_invoice_due_date";
export const VENDOR_CORE_REPAIR_INVOICE_NUMBER =
  "vendor_core_repair_invoice_number";
export const VENDOR_CORE_REPAIR_INVOICE_PAID =
  "vendor_core_repair_invoice_paid";

const REQUIRES_8130_3 = "requires_8130_3";
const REQUIRES_TRACE_DOCUMENTATION = "requires_trace_documentation";
const REQUIRES_WEIGHT_AND_DIMS = "requires_weight_and_dims";
const REQUIRES_PICTURE = "requires_picture";
const TBD = "tbd";

export const BUYER_CREDIT_PCT_OPTIONS = [
  { text: "75%", value: "75.0" },
  { text: "50%", value: "50.0" },
  { text: "25%", value: "25.0" }
];

export const DO_NOT_SHIP_REASONS = [
  REQUIRES_8130_3,
  REQUIRES_TRACE_DOCUMENTATION,
  REQUIRES_WEIGHT_AND_DIMS,
  REQUIRES_PICTURE,
  TBD
];

export const REPAIR = "repair";
export const OVERHAUL = "overhaul";
export const BENCH_TEST = "bench_test";
export const PURCHASE_ORDER = "purchase_order";

export const CAP_TYPES = {
  [REPAIR]: {
    label: "Repair"
  },
  [OVERHAUL]: {
    label: "Overhaul"
  },
  [BENCH_TEST]: {
    label: "Bench Test"
  }
};

export const TOOLS_USED = [
  { value: "my_shopping_list", text: "My Shopping List" },
  { value: "parts_watch", text: "Parts Watch" },
  { value: "dcr", text: "DCR" },
  { value: "nplb", text: "NPLB" },
  { value: "piss", text: "PISS" },
  { value: "other", text: "Other" }
];

export const CANCELLATION_REASONS = [
  {
    value: "cancelled_by_vendor_or_previously_sold",
    text: "Cancelled by Vendor or Prev. Sold"
  },
  { value: "cancelled_by_tenant", text: "Cancelled by Us" },
  { value: "part_deemed_ber", text: "Part Deemed B.E.R" },
  { value: "unacceptable_documentation", text: "Unacceptable Documentation" },
  { value: "vendor_cant_find", text: "Vendor Can't Find" },
  { value: "unethical_behavior_detected", text: "Unethical Behavior Detected" },
  { value: "unknown", text: "No Explanation/Unknown" }
];

export const ATTACHMENT_TYPES = {
  customer_purchase_order: {
    label: "Customer Purchase Order"
  },
  vendor_correspondence: {
    label: "Vendor Correspondence"
  },
  traceability: {
    label: "Traceability"
  },
  tag_copies: {
    label: "Tag Copies"
  },
  packing_slip: {
    label: "Packing Slip"
  },
  photos: {
    label: "Photos"
  },
  signed_exchange_agreement: {
    label: "Signed Exchange Agreement"
  },
  external_link: {
    label: "External Link"
  },
  end_user_agreement: {
    label: "End User Agreement"
  }
};

export const WARRANTY_PERIOD = {
  thirty_days: {
    label: "30 Days"
  },
  sixty_days: {
    label: "60 Days"
  },
  ninety_days: {
    label: "90 Days"
  },
  one_hundred_twenty_days: {
    label: "120 Days"
  },
  six_months: {
    label: "6 Months"
  },
  one_year: {
    label: "1 Year"
  },
  eighteen_months: {
    label: "18 Months"
  },
  twenty_four_months: {
    label: "24 Months"
  },
  thirty_six_months: {
    label: "36 Months"
  },
  warranty_by_mro: {
    label: "Warranty by MRO"
  },
  no_warranty: {
    label: "No Warranty"
  },
  no_warranty_thirty_day_inspection: {
    label: "No Warranty, 30 Day Inspection"
  }
};

export const PURCHASE_ORDER_QUICKBOOKS_TYPES = [
  { text: "Bill", value: "bill" },
  { text: "Purchase Order", value: "purchase_order" }
];



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/constants.js